var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8984 0C10.1278 0 4.89468 3.15715 1.0332 8.2852C0.718101 8.70533 0.718101 9.29228 1.0332 9.71241C4.89468 14.8466 10.1278 18.0038 15.8984 18.0038C21.669 18.0038 26.9021 14.8466 30.7635 9.71859C31.0786 9.29846 31.0786 8.71151 30.7635 8.29138C26.9021 3.15715 21.669 0 15.8984 0ZM16.3123 15.3409C12.4817 15.5819 9.3184 12.4247 9.55936 8.58794C9.75707 5.42461 12.3211 2.86059 15.4844 2.66288C19.315 2.42192 22.4783 5.57907 22.2374 9.41585C22.0335 12.573 19.4695 15.137 16.3123 15.3409ZM16.1208 12.4124C14.0572 12.5421 12.352 10.8431 12.4879 8.77947C12.5929 7.07424 13.9769 5.69646 15.6821 5.58525C17.7457 5.45551 19.4509 7.15456 19.315 9.21814C19.2038 10.9295 17.8198 12.3073 16.1208 12.4124Z",
    fill: "#A0A49F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f443c16d.svg";
export { ForwardRef as ReactComponent };